import {observable} from 'mobx';
import util from "../util/Util";
import SlotModel from "../models/SlotModel";
import {gql} from "apollo-boost";
import ApolloProxy from "../network/ApolloProxy";
import apoloClient from "../storage/ApoloClientInstance";
import ScheduleVisitSlotModel from "../models/ScheduleVisitSlotModel";


class SlotState {

    @observable scheduleSlots = [];

    async reloadScheduleSlotsFromScheduleVisitId(scheduleVisitId) {
        console.log("reloadScheduleSlotsFromOrderId scheduleVisitId:" + scheduleVisitId);
        let scheduleSlotsQuery = new ScheduleVisitSlotModel();
        scheduleSlotsQuery.scheduleVisitId = scheduleVisitId;
        if (util.hasValue(scheduleSlotsQuery.scheduleVisitId)) {
            let result = await scheduleSlotsQuery.findPlainObject();
            if (result == null) {
                result = [];
            }
            this.scheduleSlots = result;
        }
    }


}

export default SlotState;
